import Entity from 'utilities/entity';
import Evidence from './evidence';

class Portfolio extends Entity {
    
    content() {
        return this.hasMany(Evidence);
    }

}

export default new Portfolio();